{
  "home": {
    "tagline": "Πάνω από 1 εκατομμύριο ιδιοκτήτες σκύλων εκπαιδεύονται με το Hundeo",
    "subline": "Συνιστάται από επαγγελματίες εκπαιδευτές σκύλων",
    "appStorePrefix": "Κατέβασέ το από το",
    "playStorePrefix": "Διαθέσιμο στο",
    "qrHint": "Άνοιξε την εφαρμογή στο κινητό σου",
    "qrCaption": "Σκάναρε τον κωδικό με την κάμερα",
    "socialProof": "5.000+ πεντάστερες κριτικές",
    "imprint": "Imprint",
    "privacy": "Απόρρητο",
    "language": "Γλώσσα",
    "openWebsite": "Στην ιστοσελίδα",
    "openInApp": "Άνοιγμα στην εφαρμογή Hundeo",
    "openInAppHint": "Θα μεταφερθείς στην εφαρμογή σου",
    "openInAppButton": "Άνοιγμα",
    "promoRedirectTitle": "Ανοίγει η προσφορά σου …",
    "promoRedirectButton": "Συνέχεια στην προσφορά"
  }
}
